import { io, Socket } from "socket.io-client";
import { API_BASE_URL } from "../api/api";

class SocketService {
  private socket: Socket | null = null;

  connect(userFactId: number) {
    this.socket = io(API_BASE_URL, {
      auth: { user_fact_id: userFactId },
    });

    return this.socket;
  }

  getSocket() {
    return this.socket;
  }

  disconnect() {
    this.socket?.disconnect();
  }
}

export const socketService = new SocketService();
